import React from "react"
import { ReactComponent as Arrow } from "../../assets/arrow-right.svg"
import { Span } from "../styles/TextStyles.styled"
import styled from "styled-components"
import device from "../../theme/devices"
import { graphql, useStaticQuery } from "gatsby"

export const BackButtonContainer = styled.div`
  cursor: pointer;
  grid-row: 1;
  grid-column: 1 / 2;
  > span {
    display: none;
  }
  @media (${device.tablet}) {
    > span {
      display: inline;
    }
  }
  @media (${device.desktop}) {
    grid-row: 1;
    grid-column: 2 / 4;
  }
`

const BackButton = ({ label, locale, ...props }) => {
  const { labels } = useStaticQuery(graphql`
    {
      labels: allDatoCmsTranslation {
        edges {
          node {
            locale
            back
          }
        }
      }
    }
  `)
  return (
    <BackButtonContainer {...props}>
      <Arrow style={{ transform: "rotate(180deg)" }} />
      <Span style={{ marginLeft: "10px" }}>
        {label ||
          (locale &&
            labels.edges.find(e => e.node.locale === locale).node.back)}
      </Span>
    </BackButtonContainer>
  )
}

export default BackButton
